import moment from "moment";
import { UPDATE_DATA } from "./updateData";
// ------------------------------------
// Constants
// ------------------------------------
export const ADD_INITIAL_VALUE = "ADD_INITIAL_VALUE";
export const DELETE_INITIAL_VALUE = "DELETE_INITIAL_VALUE";
export const SET_INITIAL_VALUES = "SET_INITIAL_VALUES";
export const SET_UPDATED_VALUES = "SET_UPDATED_VALUES";
export const ADD_CHANGE_TO_HISTORY = "ADD_CHANGE_TO_HISTORY";
export const UNDO_CHANGES = "UNDO_CHANGES";
export const CLEAR_HISTORY = "CLEAR_HISTORY";
export const DELETE_HISTORY = "DELETE_HISTORY";
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  undoAction,
  addChangesToHistory,
};

export function saveInitialValues(page, values) {
  return {
    type: SET_INITIAL_VALUES,
    payload: {
      values,
      page,
    },
  };
}

export function setUpdatedValues(page, values) {
  return {
    type: SET_UPDATED_VALUES,
    payload: {
      values,
      page,
    },
  };
}

export function addInitialValue(page, field, additionalValue) {
  return {
    type: ADD_INITIAL_VALUE,
    payload: {
      additionalValue,
      field,
      page,
    },
  };
}

export function deleteInitialValueAt(location, arrayIndex) {
  return {
    type: DELETE_INITIAL_VALUE,
    payload: {
      page: location.page,
      field: location.field,
      index: arrayIndex,
    },
  };
}

export function removeUndoHistory(undoHistoryItem) {
  return {
    type: DELETE_HISTORY,
    payload: { undoHistoryItem },
  };
}

function checkType(valueType) {
  let type = "";
  switch (valueType) {
    case "textinput":
    case "textinputarray":
      type = "textValues";
      return type;
    case "datetime":
      type = "dateTime";
      return type;
    case "select":
    case "selectarray":
    case "switch":
      type = "radio";
      return type;
    case "ch":
    case "ch_uncheck":
      type = "boolValues";
      return type;
  }
}

export function undoActionFor(undoData, location, arrayIndex, allInLocation) {
  const undoDataIndex = undoData.history.findIndex((data) => {
    return (
      data.location.page === location.page &&
      data.location.field === location.field &&
      data.arrayIndex === arrayIndex
    );
  });

  return undoActionAt(
    undoData,
    undoDataIndex,
    true,
    allInLocation,
    location,
    arrayIndex
  );
}

export function undoAction(undoData) {
  const dataLength = undoData.history.length;
  const undoDataIndex = dataLength - 1;

  return undoActionAt(undoData, undoDataIndex);
}

export function undoActionAt(
  undoData,
  undoDataIndex,
  noUpdate,
  allInLocation,
  originLocation,
  originArrayIndex
) {
  const undoHistory =
    undoDataIndex != -1
      ? undoData.history[undoDataIndex]
      : {
          location: originLocation,
          arrayIndex: originArrayIndex,
          valueType: "",
          valueID: "",
        };

  const { location, valueType, valueID, arrayIndex } = undoHistory;
  const type = checkType(valueType);

  const fieldValue =
    undoDataIndex == -1
      ? ""
      : valueType.includes("array")
      ? undoData.initialValues[location.field][arrayIndex][type][valueID]
      : undoData.initialValues[location.field][type][valueID];

  const invalidDates = document.querySelectorAll(".invalid-date");

  for (let i = 0; i < invalidDates.length; i++) {
    if (undoHistory.fieldValue === invalidDates[i].value) {
      invalidDates[i].classList.remove("invalid-date");
    }
  }

  let dispValueType = valueType;
  let dispFieldValue = fieldValue || valueType === "datetime" ? fieldValue : "";

  if (type === "boolValues") {
    dispValueType = valueType === "ch" ? "ch_uncheck" : "ch";
    dispFieldValue = !undoHistory.fieldValue;
  }

  return (dispatch) => {
    if (!noUpdate) {
      dispatch({
        type: UPDATE_DATA,
        location,
        valueType: dispValueType,
        payload: {
          value: valueID,
          fieldValue: dispFieldValue,
          arrayIndex,
        },
      });
    }

    return dispatch({
      type: UNDO_CHANGES,
      payload: {
        location,
        valueType: dispValueType,
        valueID,
        arrayIndex,
        allInLocation,
      },
    });
  };
}

export function addChangesToHistory(
  location,
  valueType,
  valueID,
  fieldValue,
  arrayIndex
) {
  return {
    type: ADD_CHANGE_TO_HISTORY,
    payload: {
      location,
      valueType,
      valueID,
      fieldValue,
      arrayIndex,
    },
  };
}

export function clearHistory(page) {
  return { type: CLEAR_HISTORY, payload: { page } };
}

function checkContactInfo(htmlValue) {
  let html = "";
  if (htmlValue && !htmlValue.includes("<a")) {
    const matchEmailRegExp = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const matchReturnRegExp = /\r\n/gim;
    const emailArr = htmlValue.match(matchEmailRegExp);
    const email = emailArr
      ? `<a href="mailto:${emailArr[0]}">${emailArr[0]}</a>`
      : "";
    const contactInfoWithoutEmail = emailArr
      ? htmlValue.slice(0, emailArr.index).split(matchReturnRegExp).join("<br>")
      : htmlValue.split(matchReturnRegExp).join("<br>");
    html = `${contactInfoWithoutEmail} ${email}`;
  } else {
    html = htmlValue;
  }
  return html;
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ADD_INITIAL_VALUE]: (state, action) => {
    const { additionalValue, field, page } = action.payload;

    const history = state[page].history;
    let newUndoHistory = [];

    for (let i = 0; i <= history.length - 1; i++) {
      const newHistory = {
        ...history[i],
        arrayIndex:
          history[i].location.page == page && history[i].location.field == field
            ? history[i].arrayIndex + 1
            : history[i].arrayIndex,
      };
      newUndoHistory = [...newUndoHistory, newHistory];
    }

    return {
      ...state,
      [page]: {
        ...state[page],
        history: newUndoHistory,
        initialValues: {
          ...state[page].initialValues,
          [field]: [additionalValue, ...state[page].initialValues[field]],
        },
      },
    };
  },
  [DELETE_INITIAL_VALUE]: (state, action) => {
    const { field, page, index } = action.payload;
    const newFieldInitialValues = [...state[page].initialValues[field]];
    newFieldInitialValues.splice(index, 1);

    const newInitialValues = {
      ...state[page],
      initialValues: {
        ...state[page].initialValues,
        [field]: newFieldInitialValues,
      },
    };

    return {
      ...state,
      [page]: newInitialValues,
    };
  },
  [SET_INITIAL_VALUES]: (state, action) => {
    const { values, page } = action.payload;
    return {
      ...state,
      [page]: {
        ...state[page],
        initialValues: values,
      },
    };
  },
  [SET_UPDATED_VALUES]: (state, action) => {
    const { values, page } = action.payload;
    return {
      ...state,
      [page]: {
        ...state[page],
        initialValues: {
          ...state[page].initialValues,
          values,
        }
      },
    };
  },
  [ADD_CHANGE_TO_HISTORY]: (state, action) => {
    const { location, valueType, valueID, fieldValue, arrayIndex } =
      action.payload;
    let newHistory = [...state[location.page].history];
    newHistory = [...state[location.page].history, action.payload];
    const type = checkType(valueType);
    try {
      const initialValue =
        valueType === "textinputarray" || valueType === "selectarray"
          ? state[location.page].initialValues[location.field][arrayIndex][
              type
            ][valueID]
          : state[location.page].initialValues[location.field][type][valueID];
      if (type == "boolValues" && fieldValue === initialValue) {
        newHistory = newHistory.filter((item) => item.valueID !== valueID);
      } else if (
        fieldValue === initialValue ||
        (valueType === "textinput" &&
          initialValue &&
          initialValue.toString().replace(/(\r\n|\n|\r)/gm, "") ===
            fieldValue.toString().replace(/(\r\n|\n|\r)/gm, "")) ||
        (valueType === "textinput" &&
          fieldValue &&
          (checkContactInfo(fieldValue.toString()) ===
            checkContactInfo(initialValue.toString()) ||
            fieldValue === initialValue))
      ) {
        newHistory = newHistory.filter((item) => item.valueID !== valueID);
      }
      if (
        valueType === "datetime" &&
        moment(fieldValue, "MMM / DD / YYYY") === initialValue
      ) {
        newHistory = newHistory.filter((item) => item.valueID !== valueID);
      }
    } catch (ex) {
      console.log("undo error: " + ex.message);
    }
    return {
      ...state,
      [location.page]: {
        ...state[location.page],
        history: newHistory,
      },
    };
  },
  [UNDO_CHANGES]: (state, action) => {
    const { location, valueType, valueID, arrayIndex, allInLocation } =
      action.payload;
    const undoHistory = state[location.page].history;
    let dates = [];
    let newUndoHistory = [];

    if (valueType === "ch" || valueType == "ch_uncheck") {
      for (let i = 0; i < undoHistory.length - 1; i++) {
        newUndoHistory = [...newUndoHistory, undoHistory[i]];
      }
    } else {     

      newUndoHistory = undoHistory.filter((history) => {
        const samePageField =
          location.page === history.location.page &&
          location.field === history.location.field;
        const exactField =
          history.valueType === valueType && history.valueID === valueID;
        const sameIndex = history.arrayIndex === arrayIndex;
        const samePageFieldIndex = samePageField && sameIndex;

        const forceRemovalOfEntries = (history.location.page == 'RTI' && history.location.field == 'recordInfo' && history.valueId == 'teams');

        if (forceRemovalOfEntries){
          return false;
        }else{
          return allInLocation
            ? !samePageFieldIndex
            : !samePageFieldIndex || !exactField;
        }
      });

      if (allInLocation) {
        newUndoHistory.forEach((history, index) => {
          if (
            location.page === history.location.page &&
            location.field === history.location.field &&
            history.arrayIndex > arrayIndex
          ) {
            newUndoHistory[index].arrayIndex -= 1;
          }
        });
      }
    }

    return {
      ...state,
      [location.page]: {
        ...state[location.page],
        history: newUndoHistory,
      },
    };
  },
  [CLEAR_HISTORY]: (state, action) => {
    const { page } = action.payload;
    const changes = document.querySelectorAll(".input-changed");
    for (let i = 0; i < changes.length; i++) {
      changes[i].classList.remove("input-changed");
    }
    return {
      ...state,
      [page]: {
        ...state[page],
        history: [],
      },
    };
  },
  [DELETE_HISTORY]: (state, action) => {
    const { undoHistoryItem } = action.payload;
    console.log(undoHistoryItem);

    const { location, valueType, valueID, arrayIndex } =
      action.payload.undoHistoryItem;

    const undoHistory = state[location.page].history;

    let newUndoHistory = undoHistory.filter((history) => {
      return (
        history.location.field != location.field ||
        history.arrayIndex != arrayIndex ||
        history.valueID != valueID ||
        history.valueType != valueType
      );
    });

    return {
      ...state,
      [location.page]: {
        ...state[location.page],
        history: newUndoHistory,
      },
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  OR: {
    initialValues: {},
    history: [],
  },
  RR: {
    initialValues: {},
    history: [],
  },
  RU: {
    initialValues: {},
    history: [],
  },
  RBD: {
    initialValues: {},
    history: [],
  },
  G: {
    initialValues: {},
    history: [],
  },
  LTI: {
    initialValues: {},
    history: [],
  },
  LOTI: {
    initialValues: {},
    history: [],
  },
  SR: {
    initialValues: {},
    history: [],
  },
  LDP: {
    initialValues: {},
    history: [],
  },
  RTI: {
    initialValues: {},
    history: [],
  },
};
export default function undoReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/undo.js